import config from '@at/design-system-tokens/dist/config.json';
export var iconConfig = function () {
    var iconData = [];
    var iconConfig = config.v1.icons.sizes;
    iconData = JSON.parse(JSON.stringify(iconConfig));
    return iconData;
};
